import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const structure = {
    name: 'structure',
    type: 'autocomplete',
    label: 'structure',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const meter = {
    name: 'meter',
    type: 'autocomplete',
    label: 'meter',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const date = {
    name: 'date',
    rules: {required: true},
    type: 'datepicker',
    sm: 6,
    xs: 12,
}

const value = {
    name: 'value',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

export const createMeterReadingField = {
    createMeterReading: {
        title: 'createMeterReading',
        items: {
            structure,
            meter,
            date,
            value,
        },
    },
}

export const editMeterReadingField = {
    editMeterReading: {
        title: 'editMeterReading',
        items: {
            structure: {...structure, readOnly: true},
            meter: {...meter, readOnly: true},
            date,
            value,
        },
    },
}

export const createMeterReadingFieldValidation = z.object({
    structure: ZodConfig.stringDocument(),
    meter: ZodConfig.stringDocument(),
    date: ZodConfig.date(),
    value: ZodConfig.number({min: 0}),
})
